module.exports = __webpack_public_path__ + "static/media/cursos.8218c0f0.jpg";